export const staffMembersSickDaysEndpoint = (staffMemberId: string, year: number | string) => `/staff-members/${staffMemberId}/sick-days/${year}`;
